import { iconButtonClasses as MUIIconButtonClasses } from '@mui/material/IconButton';

export const IconButtonClasses = {
  ...MUIIconButtonClasses,
};

const styles = {
  IconButton: {},
};

export default styles;
